import { render, staticRenderFns } from "./AlertCustom.vue?vue&type=template&id=1cd17d96"
import script from "./AlertCustom.vue?vue&type=script&lang=js"
export * from "./AlertCustom.vue?vue&type=script&lang=js"
import style0 from "./AlertCustom.vue?vue&type=style&index=0&id=1cd17d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports